var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRef, useState } from 'react';
import { useAnimateTransition, useId } from '../hooks';
import { Overlay } from '../overlay';
import { Portal } from '../portal';
import { ModalProvider } from './modal-context';
import Panel from './panel';
function ModalInternal(_a) {
    var _b = _a.alignCenter, alignCenter = _b === void 0 ? false : _b, ariaLabel = _a["aria-label"], children = _a.children, context = _a.context, _c = _a.disableOverlay, disableOverlay = _c === void 0 ? false : _c, _d = _a.disablePortal, disablePortal = _d === void 0 ? false : _d, floatingProps = _a.floatingProps, isOpen = _a.isOpen, _e = _a.size, size = _e === void 0 ? 'medium' : _e, restProps = __rest(_a, ["alignCenter", 'aria-label', "children", "context", "disableOverlay", "disablePortal", "floatingProps", "isOpen", "size"]);
    var id = "modal-".concat(useId());
    var isAnimating = useAnimateTransition(isOpen, 300);
    var autoFocusRef = createRef();
    var _f = __read(useState(), 2), headerId = _f[0], setHeaderId = _f[1];
    var _g = __read(useState(), 2), bodyId = _g[0], setBodyId = _g[1];
    var _h = __read(useState(false), 2), hasDecorativeHeader = _h[0], setHasDecorativeHeader = _h[1];
    function renderContent() {
        var panelProps = __assign({ ariaLabel: ariaLabel, children: children, context: context, floatingProps: floatingProps, isVisible: isOpen }, restProps);
        return disableOverlay ? (_jsx(Panel, __assign({}, panelProps))) : (_jsx(Overlay, __assign({ "data-testid": "modal-overlay", isVisible: isOpen }, { children: _jsx(Panel, __assign({}, panelProps)) })));
    }
    return (_jsx(ModalProvider, __assign({}, {
        alignCenter: alignCenter,
        autoFocusRef: autoFocusRef,
        bodyId: bodyId,
        hasDecorativeHeader: hasDecorativeHeader,
        headerId: headerId,
        id: id,
        setBodyId: setBodyId,
        setHasDecorativeHeader: setHasDecorativeHeader,
        setHeaderId: setHeaderId,
        size: size,
    }, { children: disablePortal ? (isAnimating && renderContent()) : (_jsx(Portal, { children: isAnimating && renderContent() })) })));
}
export default ModalInternal;
